import { Box, Container } from "@mui/material";
import { UsersBreadcrumb } from "./constant";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import Breadcrumb from "../../../common/Breadcrumb";
import { useStyles } from "./style";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import EzNotFound from "../../../common/EzNotFound";
import EzTable from "../../../common/EzTable";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const Users = (props) => {
  const classes = useStyles();
  const {
    tableData,
    isLoading,
    paginationInfo,
    screenPermissions,
    isPageLevelError,
    fetchUsersInfos,
    setDeleteConfirmationPopupVisibility,
    handleEditUsers,
    handleCreateUsers,
    savedTableState,
    onTableStateChange,
  } = props;
  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);

  const convertToTSV = (data) => {
    const headers = data.columns
      .map((item) => item.colLabel)
      .join("\t");
    
    const rows = data.rows
      .map((row) => {
        return data.columns
          .map((col) => {
            const value = row[col.dataKey];
            if (value === null || value === undefined) {
              return '-';
            }
            return String(value);
          })
          .join("\t");
      })
      .join("\n");
    
    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => {
        console.error('Copy failed:', err);
        setIsCopy(false);
      });
  };

  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);

  const handlePrint = () => {
    const success = printTableData({
      title: "Users",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
    });
    if (!success) {
      setIsPrintError(true);
    }
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Users</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {screenPermissions?.create && (
                <Button
                  label={"Create User"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateUsers}
                />
              )}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              {/* <Button
              label={"Excel"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px" }}
              onClick={exportSystemUsers}
            /> */}
              {/* <Button
              label={"CSV"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px" }}
              onClick={exportCSVSystemUsers}
            /> */}
              {/* <Button
              label={"PDF"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px" }}
              onClick={exportPDFSystemUsers}
            /> */}
              <Button
              label={"Print"}
              className={` p-button-raised`}
              style={{ borderRadius: "0px" }}
              onClick={handlePrint}
            />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const filters = {
    global: { value: null },
    username: { value: null, filterKey: "username" },
    roleTitle: { value: null, filterKey: "roleTitle" },
    alias: { value: null, filterKey: "alias" },
    creationTimestamp: { value: null, filterKey: "creationTimestamp" },
    modificationTimestamp: { value: null, filterKey: "modificationTimestamp" },
    createdBy: { value: null, filterKey: "createdBy" },
    modifiedBy: { value: null, filterKey: "modifiedBy" },
    locationTitles: { value: null, filterKey: "locationTitles" },
    status: { value: null, filterKey: "status" },
  };

  // Build initial filters from saved state if available
  const getInitialFilters = () => {
    const defaultFilters = { ...filters };

    // If we have saved filters, merge them with defaults
    if (savedTableState?.filters) {
      const savedFilters = savedTableState.filters;
      Object.keys(savedFilters).forEach(key => {
        if (defaultFilters[key]) {
          defaultFilters[key] = { ...defaultFilters[key], ...savedFilters[key] };
        }
      });
    }

    return defaultFilters;
  };

  const initialFilters = getInitialFilters();

  const getToastProps = () => {
    let toastTitle = "";
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderUsersRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderUsersRecords() && !shouldRenderFullPageError();

  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    areFiltersVisible,
    value: tableData?.rows,
    emptyMessage: "No Users found.",
    loadLazyData: fetchUsersInfos,
    filters: initialFilters,
    loading: isLoading,
    showMoreActions: false,
    sortField: savedTableState?.sortField || null,
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    onTableStateChange,
    onEditRecord: handleEditUsers,
    setDeleteConfirmationPopupVisibility,
    showViewButton: false,
    showCopyButton: false,
    showDeleteButton: false,
    showEditButton: true,
  };

  return (
    <div>
      <Container maxWidth="lg">
        <Breadcrumb list={UsersBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderUsersRecords() && (
              <Box>
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Users records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Users;
